<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTimer_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5 1.966C5 1.432 5.432 1 5.965 1h5.07a.966.966 0 0 1 0 1.931H9.5v1.536c2.56.454 4.5 2.62 4.5 5.223C14 12.623 11.538 15 8.5 15S3 12.623 3 9.69c0-2.604 1.94-4.77 4.5-5.223V2.93H5.965A.966.966 0 0 1 5 1.966m7.498 5.474-2.73 2.597c-.25.238-.59.326-.905.273a1.04 1.04 0 0 1-.675-.413.97.97 0 0 1-.153-.832c.075-.273.27-.517.56-.65l3.463-1.583c.396-.18.752.31.44.608"
        clip-rule="evenodd"
    />
</svg>
